import React from "react";
import {
  MessageCircle,
  Phone,
  Briefcase,
  Bot,
  Sparkles,
  Lock,
  Check,
  Rocket,
  Send,
  Search,
  Smartphone,
} from "lucide-react";

export default function ComoFunciona({ conteudo }) {
  return (
    <section
      id="recursos"
      className="py-12 md:py-28 px-4 md:px-6"
      data-testid="como-funciona"
    >
      <div className="max-w-7xl mx-auto">
        {/* Tudo isso está incluso */}
        <div className="mt-0">
          <div className="text-center mb-10 md:mb-12 max-w-2xl lg:max-w-none mx-auto">
            <span className="inline-block text-sm font-semibold text-green-400 uppercase tracking-wider mb-3">
              Tudo isso está incluso
            </span>
            <h3 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white mb-3 tracking-tight">
              CRM completo com <span className="bg-gradient-to-r from-green-400 to-emerald-300 bg-clip-text text-transparent">Inteligência Artificial</span> para transformar sua operação.
            </h3>
            <p className="text-lg md:text-xl text-zinc-400 leading-relaxed max-w-3xl mx-auto">
              Tenha tudo conectado: atendimento multicanal, CRM, vendas, automações e IA
              em uma única plataforma para organizar sua operação, ganhar produtividade
              e fazer seu negócio crescer.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
            {/* Card 1 — Multichannel */}
            <div className="p-5 bg-[#111111] border border-white/5 rounded-xl hover:border-green-500/30 transition-all">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center flex-shrink-0">
                  <MessageCircle className="w-5 h-5 text-green-500" />
                </div>
                <h4 className="text-white font-bold text-base">
                  Atendimento Multichannel + IA
                </h4>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed mb-3">
                WhatsApp, Instagram, Messenger e Telegram numa única tela. IA
                atendendo todos os canais.
              </p>
              <div className="flex items-center flex-wrap gap-3 mt-3">
                {/* WhatsApp */}
                <div
                  className="w-8 h-8 rounded-lg bg-[#25D366]/10 border border-[#25D366]/20 flex items-center justify-center"
                  title="WhatsApp"
                >
                  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#25D366">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                </div>
                {/* Instagram */}
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center overflow-hidden"
                  title="Instagram"
                  style={{
                    background:
                      "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                  }}
                >
                  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="white">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </div>
                {/* Messenger */}
                <div
                  className="w-8 h-8 rounded-lg bg-[#0084FF]/10 border border-[#0084FF]/20 flex items-center justify-center"
                  title="Messenger"
                >
                  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#0084FF">
                    <path d="M12 0C5.373 0 0 4.974 0 11.111c0 3.498 1.744 6.614 4.469 8.652V24l4.088-2.242c1.092.3 2.246.464 3.443.464 6.627 0 12-4.974 12-11.111S18.627 0 12 0zm1.191 14.963l-3.055-3.26-5.963 3.26L10.732 8l3.131 3.259L19.752 8l-6.561 6.963z" />
                  </svg>
                </div>
                {/* Telegram */}
                <div
                  className="w-8 h-8 rounded-lg bg-[#0088CC]/10 border border-[#0088CC]/20 flex items-center justify-center"
                  title="Telegram"
                >
                  <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#0088CC">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                  </svg>
                </div>
                {/* Separador "+" */}
                <span className="text-zinc-600 text-lg font-light px-1">+</span>

                {/* VoIP destacado */}
                <div className="flex items-center gap-1.5 px-2.5 h-8 rounded-lg bg-gradient-to-r from-green-500/15 to-blue-500/15 border border-green-500/30" title="VoIP">
                  <Phone className="w-3.5 h-3.5 text-green-400" />
                  <span className="text-xs font-bold text-white">VoIP</span>
                </div>
              </div>
            </div>

            {/* Card 2 — VoIP */}
            <div className="p-5 bg-[#111111] border border-white/5 rounded-xl hover:border-blue-500/30 transition-all relative">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5 text-blue-400" />
                </div>
                <h4 className="text-white font-bold text-base">
                  Ligações VoIP
                </h4>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed mb-3">
                Discador integrado no painel. Receba e faça ligações pelo
                computador.
              </p>
              <p className="text-[11px] text-zinc-500 italic">
                * Disponível nos planos Start e Pro.
              </p>
            </div>

            {/* Card 3 — CRM */}
            <div className="p-5 bg-[#111111] border border-white/5 rounded-xl hover:border-green-500/30 transition-all">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center flex-shrink-0">
                  <Briefcase className="w-5 h-5 text-green-500" />
                </div>
                <h4 className="text-white font-bold text-base">
                  CRM + Gestão
                </h4>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed mb-3">
                Gestão completa integrada ao atendimento. Sem precisar de
                outro software.
              </p>
              <ul className="space-y-1">
                <li className="flex items-center gap-1.5 text-xs text-zinc-300">
                  <Check className="w-3 h-3 text-green-500 flex-shrink-0" />
                  Cadastro de clientes
                </li>
                <li className="flex items-center gap-1.5 text-xs text-zinc-300">
                  <Check className="w-3 h-3 text-green-500 flex-shrink-0" />
                  Produtos e estoque
                </li>
                <li className="flex items-center gap-1.5 text-xs text-zinc-300">
                  <Check className="w-3 h-3 text-green-500 flex-shrink-0" />
                  Financeiro completo
                </li>
              </ul>
            </div>

            {/* Card 4 — Versão web e mobile */}
            <div className="p-5 bg-[#111111] border border-white/5 rounded-xl hover:border-green-500/30 transition-all">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center flex-shrink-0">
                  <Smartphone className="w-5 h-5 text-green-500" />
                </div>
                <h4 className="text-white font-bold text-base">
                  Versão web e mobile disponíveis
                </h4>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed mb-4">
                Versão web e aplicativo mobile pra baixar nas lojas.
              </p>
              <div className="grid grid-cols-2 gap-2">
                {/* Card Google Play */}
                <a
                  href="https://play.google.com/store/apps/details?id=com.evolzap.mobile&hl=pt_BR"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Baixar Evolzap na Google Play Store"
                  className="flex flex-col items-center justify-center gap-1.5 p-3 bg-[#0d0d0d] border border-white/10 rounded-lg cursor-pointer hover:border-green-500/40 hover:bg-[#141414] hover:scale-[1.02] transition-all group"
                >
                  <svg viewBox="0 0 24 24" className="w-7 h-7 group-hover:scale-105 transition-transform">
                    <path fill="#FFC107" d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594z" />
                    <path fill="#FF3D00" d="M1.337.924a1.486 1.486 0 0 0-.337.963v20.225c0 .371.13.708.34.972l11.146-11.092L1.337.924z" />
                    <path fill="#4CAF50" d="M14.584 12.023l-3.543 3.521L1.34 22.084c.204.257.504.428.851.476.396.054.8-.029 1.137-.235l13.183-7.464-1.927-2.838z" />
                    <path fill="#1976D2" d="M14.584 12.023l1.927-2.838L3.328 1.721A1.482 1.482 0 0 0 2.19 1.486a1.49 1.49 0 0 0-.853.475l9.704 9.643 3.543-3.521z" />
                  </svg>
                  <div className="text-center">
                    <div className="text-zinc-500 text-[9px] leading-none mb-0.5">Disponível no</div>
                    <div className="text-white font-bold text-xs">Google Play</div>
                  </div>
                </a>
                {/* Card App Store */}
                <div className="relative flex flex-col items-center justify-center gap-1.5 p-3 bg-[#0d0d0d] border border-white/10 rounded-lg cursor-default opacity-60">
                  <span className="absolute top-2 right-2 text-[10px] font-semibold px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-400 border border-amber-500/30">
                    Em breve
                  </span>
                  <svg viewBox="0 0 24 24" className="w-7 h-7" fill="#FFFFFF">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                  </svg>
                  <div className="text-center">
                    <div className="text-zinc-500 text-[9px] leading-none mb-0.5">Baixe na</div>
                    <div className="text-white font-bold text-xs">App Store</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 5 — Ivo (destaque) */}
            <div className="p-5 bg-gradient-to-br from-green-500/[0.06] to-blue-500/[0.06] border border-green-500/30 rounded-xl hover:border-green-500/50 transition-all relative">
              <div className="absolute top-3 right-3 inline-flex items-center gap-1 px-2 py-0.5 bg-green-500/20 border border-green-500/30 rounded-full">
                <Sparkles className="w-2.5 h-2.5 text-green-400" />
                <span className="text-[9px] font-bold text-green-400 uppercase tracking-wider">
                  Exclusivo
                </span>
              </div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-green-400 to-emerald-600 flex items-center justify-center flex-shrink-0">
                  <Bot className="w-5 h-5 text-black" />
                </div>
                <h4 className="text-white font-bold text-base">
                  Ivo — sua IA de gestão
                </h4>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed mb-3">
                Assistente de IA direto no seu WhatsApp. Consulta dados, executa
                ações e analisa seu negócio.
              </p>
              <div className="inline-flex items-center gap-1 text-[10px] font-medium text-green-400 bg-green-500/10 border border-green-500/20 px-2 py-1 rounded">
                <Lock className="w-3 h-3" />
                Só pro dono — não pro cliente
              </div>
            </div>

            {/* Card 6 — Venda Mais */}
            <div className="p-5 bg-[#111111] border border-white/5 rounded-xl hover:border-blue-500/30 transition-all">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center flex-shrink-0">
                  <Rocket className="w-5 h-5 text-blue-400" />
                </div>
                <h4 className="text-white font-bold text-base">Venda Mais</h4>
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed mb-4">
                Prospecção ativa e campanhas em massa pra crescer sua base de
                clientes.
              </p>
              <div className="space-y-3">
                <div>
                  <div className="flex items-center gap-1.5 mb-1.5">
                    <Send className="w-3 h-3 text-blue-400" />
                    <span className="text-[10px] font-bold text-blue-400 uppercase tracking-wider">
                      Disparo de Campanhas
                    </span>
                  </div>
                  <p className="text-xs text-zinc-300 leading-relaxed pl-4">
                    WhatsApp, Instagram, Facebook e Email em massa
                  </p>
                </div>
                <div>
                  <div className="flex items-center gap-1.5 mb-1.5">
                    <Search className="w-3 h-3 text-blue-400" />
                    <span className="text-[10px] font-bold text-blue-400 uppercase tracking-wider">
                      Prospecção Inteligente
                    </span>
                  </div>
                  <ul className="space-y-1 pl-4">
                    <li className="text-xs text-zinc-300 leading-relaxed">
                      Busca por CNPJ e segmento
                    </li>
                    <li className="text-xs text-zinc-300 leading-relaxed">
                      Análise e expansão de mercado
                    </li>
                    <li className="text-xs text-zinc-300 leading-relaxed">
                      Vendas, B2B, recrutamento e pesquisa
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Faixa de fechamento */}
            <div className="md:col-span-2 lg:col-span-3 p-6 md:p-8 bg-gradient-to-r from-green-500/[0.08] via-blue-500/[0.05] to-green-500/[0.08] border border-green-500/20 rounded-xl text-center relative overflow-hidden mt-2">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-32 bg-green-500/10 rounded-full blur-3xl pointer-events-none" />
              <div className="relative">
                <p className="text-lg md:text-xl text-white font-semibold mb-1">
                  Tudo isso por um único valor mensal
                </p>
                <p className="text-sm md:text-base text-zinc-400">
                  Sem taxas escondidas, sem cobrança por usuário extra, sem
                  fidelidade.{" "}
                  <a
                    href="#planos"
                    className="text-green-400 hover:underline font-semibold"
                  >
                    Ver planos →
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
